import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import classNames from "classnames";
import DomPurify from "isomorphic-dompurify";
import styles from "./Typography.module.scss";
const { sanitize } = DomPurify;
/**
 * @deprecated use Typography from @jti/ui instead
 */
export const DEPRECATED_Typography = forwardRef(({ type = "text", weight = "light", children, color = "white", dataTestid, className, inline, onClick }, ref) => {
    const currentClassNames = classNames(styles.typography, className, styles[`typography--${type}`], styles[`typography--${weight}`], styles[`typography--${color}`], {
        [styles["typography--inline"]]: inline,
    });
    const props = {
        className: currentClassNames,
        "data-testid": dataTestid,
        dangerouslySetInnerHTML: {
            __html: sanitize(children ? children.toString() : ""),
        },
        onClick,
    };
    switch (type) {
        case "h2":
        case "h1":
        case "table-title":
        case "table-content":
        case "large-text":
        case "medium-text":
        case "small-text":
        case "title":
        case "large-title":
        case "xlarge-title":
        case "mlarge-title":
        case "medium-title":
        case "small-title":
        case "text":
        case "redirect-link":
        case "p1":
        case "p3":
            return _jsx("div", { ref: ref, ...props });
        default:
            return null;
    }
});
//# sourceMappingURL=Typography.js.map